import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { apiJson } from "../../../../api/Api";
import { toast } from "react-toastify";

const payoutSchema = Yup.object({
  bank_name: Yup.string().required("Bank name is required"),
  bank_account_title: Yup.string().required("Account title is required"),
  bank_account_no: Yup.string().required("Account number is required"),
  bank_account_iban: Yup.string().required("IBAN is required"),
});

const PayoutStep = ({ onSuccess, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [user, setUser] = useState();

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    apiJson.vendorProfile.getVendor().then((response) => {
      if (response.success) {
        setUser(response.data);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      country_id: user?.store?.country_id ? user?.store?.country_id : 1,
      bank_name: user?.store?.bank_name,
      bank_account_title: user?.store?.bank_account_title,
      bank_account_no: user?.store?.bank_account_no,
      bank_account_iban: user?.store?.bank_account_iban,
    },
    validationSchema: payoutSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await apiJson.onboarding.updateBankDetails(values);
        if (response.success) {
          toast.success("Banking information saved successfully", {
            position: "bottom-right",
          });
          onSuccess();
        } else {
          toast.error(response.message || "Something went wrong", {
            position: "bottom-right",
          });
        }
      } catch (err) {
        toast.error(
          err?.response?.data?.message ||
            "Something went wrong. Please try again.",
          { position: "bottom-right" },
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box className="step-wrapper">
      <Typography className="step-title">Payout & Bank Details</Typography>
      <Typography className="step-subtitle">
        Provide your bank account information to receive payouts directly and on
        time.
      </Typography>

      {apiError && (
        <Box className="step-error">
          <Typography>{apiError}</Typography>
        </Box>
      )}

      <form onSubmit={formik.handleSubmit} className="step-form">
        <TextField
          name="bank_name"
          label="Bank Name"
          placeholder="Enter your bank name"
          fullWidth
          variant="outlined"
          value={formik.values.bank_name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
          helperText={formik.touched.bank_name && formik.errors.bank_name}
        />
        <TextField
          name="bank_account_title"
          label="Account Title"
          placeholder="Enter account title"
          fullWidth
          variant="outlined"
          value={formik.values.bank_account_title}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bank_account_title &&
            Boolean(formik.errors.bank_account_title)
          }
          helperText={
            formik.touched.bank_account_title &&
            formik.errors.bank_account_title
          }
        />
        <TextField
          name="bank_account_no"
          label="Account Number"
          placeholder="Enter account number"
          fullWidth
          variant="outlined"
          value={formik.values.bank_account_no}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bank_account_no &&
            Boolean(formik.errors.bank_account_no)
          }
          helperText={
            formik.touched.bank_account_no && formik.errors.bank_account_no
          }
        />
        <TextField
          name="bank_account_iban"
          label="IBAN"
          placeholder="e.g. AE070331234567890123456"
          fullWidth
          variant="outlined"
          value={formik.values.bank_account_iban}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.bank_account_iban &&
            Boolean(formik.errors.bank_account_iban)
          }
          helperText={
            formik.touched.bank_account_iban && formik.errors.bank_account_iban
          }
        />
        <Box className="step-actions">
          <Button onClick={onBack} className="step-back-btn">
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            endIcon={loading && <CircularProgress size={16} color="inherit" />}
          >
            Save & Continue
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default PayoutStep;
